export default "__VITE_ASSET__BNMrvWwu__"